<div class="not-found-page">
  <section class="not-found-card" aria-labelledby="not-found-title">
    <div class="not-found-brand"><img src="assets/images/earthscoutIcon.PNG" alt="" width="32" height="32"><span>ROOTS</span></div>
    <div class="not-found-code" aria-hidden="true">404</div>
    <h1 id="not-found-title">Page not found</h1>
    <p class="not-found-description">This page may have moved, or the address may be incorrect.<br>Use a link below to continue.</p>
    <div class="not-found-actions">
      <button mat-stroked-button type="button" (click)="navigateBack()"><mat-icon>arrow_back</mat-icon>Go back</button>
      <a mat-flat-button routerLink="/" class="not-found-primary"><mat-icon>home</mat-icon>Go to home</a>
    </div>
    <div class="not-found-directory">
      <h2>Find your page</h2>
      <nav class="not-found-links" aria-label="Available Roots pages">
        @for (data of pageData; track data.link) {
          <a [routerLink]="data.link" class="not-found-link">
            <span><small>{{ data.section }}</small><strong>{{ data.name }}</strong></span>
            <mat-icon aria-hidden="true">chevron_right</mat-icon>
          </a>
        }
      </nav>
    </div>
  </section>
</div>
